import { createSlice } from "@reduxjs/toolkit";
import { getPricingFiltersStatesAction } from "../actions/pricingDashboard.action";

const initialState = {
  isError: false,
  isLoading: false,
  data: [],
};

const pricingFiltersStatesAction = createSlice({
  name: "Get States for Pricing Filters",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPricingFiltersStatesAction.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });

    builder.addCase(getPricingFiltersStatesAction.fulfilled, (state, action) => {
      state.data = [...state.data, ...(action?.payload?.body || [])];
      state.isLoading = false;
      if (!action?.payload) state.isError = true;
      else state.isError = false;
    });

    builder.addCase(getPricingFiltersStatesAction.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export default pricingFiltersStatesAction.reducer;
